import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import Dashboard from "./pages/Dashboard";
import AuthPage from "./pages/AuthPage";
import DataConnectionsPage from "./pages/DataConnectionsPage";
import HomePage from "./pages/HomePage";
import CreditsPage from "./pages/CreditsPage";
import ProfilePage from "./pages/ProfilePage";
import AppLayout from "./components/layout/AppLayout";
import SessionManagementDemo from "./components/SessionManagementDemo";
import ProgressStyleDemo from "./pages/ProgressStyleDemo";
import KPICardPreview from "./components/KPICardPreview";
import ChartLoadingPreview from "./components/ChartLoadingPreview";

// Wrapper component for pages that use AppLayout
const AppLayoutWrapper = ({ children }) => (
  <AppLayout>{children}</AppLayout>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          
          {/* App routes with sidebar layout */}
          <Route path="/app/home" element={<AppLayoutWrapper><HomePage /></AppLayoutWrapper>} />
          <Route path="/app/session" element={<AppLayoutWrapper><Dashboard /></AppLayoutWrapper>} />
          <Route path="/app/connections" element={<AppLayoutWrapper><DataConnectionsPage /></AppLayoutWrapper>} />
          <Route path="/app/credits" element={<AppLayoutWrapper><CreditsPage /></AppLayoutWrapper>} />
          <Route path="/app/profile" element={<AppLayoutWrapper><ProfilePage /></AppLayoutWrapper>} />
          
          {/* Legacy route - redirect to new session route */}
          <Route path="/dashboard" element={<AppLayoutWrapper><Dashboard /></AppLayoutWrapper>} />
          
          {/* Demo routes */}
          <Route path="/session-demo" element={<SessionManagementDemo />} />
          <Route path="/progress-demo" element={<ProgressStyleDemo />} />
          <Route path="/kpi-preview" element={<KPICardPreview />} />
          <Route path="/loading-preview" element={<ChartLoadingPreview />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;